// src/components/Loader.jsx
import React from 'react';

export default function Loader({loading}) {
  return (
    <div className={`
        fixed inset-0 flex items-center justify-center
        bg-black/70 z-50
        transition-opacity duration-1000 ease-in-out
        ${loading ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
      `}>
    <div className="flex space-x-2">
      {[...Array(3)].map((_, i) => (
        <div
          key={i}
          className="w-4 h-4 bg-indigo-400 rounded-full animate-ping"
          style={{ animationDelay: `${i * 0.2}s` }}
        />
      ))}
    </div>
  </div>
  );
}
